import { clsx } from 'clsx'

interface FooterBottomProps {
  footer_text_bottom: string
}

export function FooterBottom({ footer_text_bottom }: FooterBottomProps) {
  return (
    <div className="py-0">
      <div className="text-center text-sm text-[#9CA3AF]">{footer_text_bottom}</div>
    </div>
  )
}
